import {
  Component,
  Inject,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { Router, RouterModule } from '@angular/router';
import { MatConnectedDialog } from '@ay-gosu/ui/common/connected-dialog';
import { FormErrorComponent } from '@ay-gosu/ui/common/form-error';
import { DialogService } from '../../dialog';
import { GosuSnsComponent } from '../gosu-sns/gosu-sns.component';
import {
  ENABLE_THIRD_PARTY_LOGIN,
  IBackstageLoginService,
  LOGIN_SERVICE,
  SERVICE_NAME,
} from '../login.service';

@Component({
  selector: 'gosu-login-form',
  imports: [
    MatFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatButtonModule,
    GosuSnsComponent,
    FormErrorComponent,
    RouterModule,
  ],
  templateUrl: './form.component.html',
})
export default class FormComponent implements OnInit {
  @ViewChild('tmpEmailExistNotBind')
  public tmpEmailExistNotBind: TemplateRef<any> = {} as TemplateRef<any>;

  public email = new FormControl('', [Validators.required]);

  public password = new FormControl('', [
    Validators.minLength(4),
    Validators.maxLength(32),
    Validators.required,
  ]);

  public form = new FormGroup({
    email: this.email,
    password: this.password,
  });

  public name = '張美香';

  public constructor(
    @Inject(SERVICE_NAME)
    public serviceName: string,
    @Inject(ENABLE_THIRD_PARTY_LOGIN)
    public readonly enableThirdPartyLogin: boolean = true,
    @Inject(LOGIN_SERVICE)
    public readonly loginService: IBackstageLoginService,
    public readonly matConnectedDialog: MatConnectedDialog,
    public readonly dialogService: DialogService,
    public readonly router: Router,
  ) {}

  public async ngOnInit(): Promise<void> {
    const showLoginOrRegisterToBuyDialog = localStorage.getItem(
      'showLoginOrRegisterToBuyDialog',
    );
    if (showLoginOrRegisterToBuyDialog) {
      await this.dialogService.confirm(
        $localize`您已經是 GOSU 會員了嗎？`,
        $localize`請先登入或註冊 GOSU 帳號並建立組織，再完成購買！`,
        {
          buttons: [
            {
              type: 'flat',
              color: 'primary',
              text: $localize`確定`,
              click: (dialogRef) => dialogRef.close(true),
            },
          ],
        },
      );
      localStorage.removeItem('showLoginOrRegisterToBuyDialog');
    }
  }

  public updateEmailAndPasswordValidity(): void {
    this.email.markAsDirty();
    this.email.updateValueAndValidity();

    this.password.markAsDirty();
    this.password.updateValueAndValidity();
  }

  public async onSubmit() {
    if (this.form.invalid) {
      this.form.markAsDirty();
      return;
    }

    const email = this.email.value as string;
    const password = this.password.value as string;
    try {
      await this.loginService.login(email, password);
    } catch (error: any) {
      if (error.code === 'ACCOUNT_OR_PASSWORD_FAIL') {
        this.email.setErrors({ wrongAccountOrPassword: true });
        this.password.setErrors({ wrongAccountOrPassword: true });
      } else if (error.code === 'PASSWORD_PUNISH') {
        this.email.setErrors({ punishTime: error.punishTime });
        this.password.setErrors({ punishTime: error.punishTime });
      } else {
        console.error(error);
      }
    }
  }
}
